import { Link } from 'react-router-dom';
import React from 'react';
import Button from 'shared/components/button/Button';
import './Title.scss';

class Title extends React.Component {
  handleSubmit = event => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit(event);
    }
  };

  render() {
    let cancelBtn = (
      <Link to={this.props.cancelLink} className="cancel-link">
        {this.props.linkText}
      </Link>
    );

    if(this.props.params) {
      cancelBtn = (
        <Link
          to={{
            pathname: this.props.cancelLink,
            params: this.props.params
          }}
          className="cancel-link"
        >
          {this.props.linkText}
        </Link>
      );
    }

    if (this.props.backBtn) {
      cancelBtn = (
        <div
          onClick={() => this.props.history.goBack()}
          className="cancel-link"
        >
          {this.props.linkText}
        </div>
      );
    }

    if (this.props.cancelBtn) {
      cancelBtn = (
        <div onClick={this.props.cancelBtn} className="cancel-link">
          {this.props.linkText}
        </div>
      );
    }

    const {
      pageTitle,
      buttonText,
      isSubmitting,
      disabled
    } = this.props;
    return (
      <div className="page-title">
        <h4>{pageTitle}</h4>
        <div className="title-action">
          {cancelBtn}
          {buttonText && (
            <Button
              id=""
              type="submit"
              color={isSubmitting ? 'secondary' : 'primary'}
              label={`${buttonText} ${isSubmitting ? '...' : ''}`}
              onClick={this.handleSubmit}
              disabled={isSubmitting || disabled}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Title;
